import axios from 'axios'
import { Decode, Encode } from '@/services'

const GetToken = () => {
  if (localStorage.getItem('oneData') !== null) {
    const oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
    const auth = {
      headers: { Authorization: `Bearer ${oneData.user.access_token}` }
    }
    return auth
  } else {
    const auth = ''
    return auth
  }
}

export default {
  async GenTokenStream (val) {
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}live_shop`, val, '')
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async LiveListProduct (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}live_list_product`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdatePinProduct (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}update_pin_product`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetPinProduct (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_pin_product`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateProductCartLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}update_product_cart_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetProductCartLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_product_cart_live_v2`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async AddComment (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}add_comment`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetComments (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_comment`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GenerateLiveShopURL (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}live/generate_live_shop`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateOverlayImg (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}update_overlay_img`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdatePositionOverlay (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}update_position_overlay`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetOverlayImg (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_overlay_img`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetOverlayDetail (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_overlay_detail`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async CheckLiveStatus (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}check_live_status`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetShopLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_shop_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async deleteRoom (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}deleteRoom`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetProfileImage (val) {
    const auth = await GetToken()
    try {
      var response = await axios.get(`${process.env.VUE_APP_LIVE_STREAM_API}get_user_img`, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async SendHeart (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}send_heart`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetHeartCount (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_heart_count`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async AddParticipant (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}add_participant`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetParticipant (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_participant`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async RemoveOverLayImage (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}clear_overlay`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetToken (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}token`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetAllRoomV2 (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_all_room_v2`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetTokenLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}token`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetStatusLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_show_live_stream`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateStatusLive (val) {
    const auth = await GetToken(val)
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}update_show_live_stream`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async DataSelectedCartLive (val) {
    const auth = await GetToken(val)
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_selected_cart_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetTokenBuyer (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}buyer/token`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async deleteRoomBuyer (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}buyer/deleteRoom`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateProductCartLiveBuyer (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}buyer/update_product_cart_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdatePinProductBuyer (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}buyer/update_pin_product`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async DataSelectedCartLiveBuyer (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}buyer/get_selected_cart_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GenerateLiveAffiliate (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}live/generate_live_affiliate`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetAffiliateID (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}affiliate/get-id`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdatePinCoupon (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}update_pin_coupon`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetPinCoupon (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_pin_coupon`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateCouponsLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}update_coupons_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetSelectedCouponsLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_selected_coupons_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateCouponsLiveBuyer (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}buyer/update_coupons_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdatePinCouponBuyer (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}buyer/update_pin_coupon`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetPinCouponBuyer (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}buyer/get_pin_coupon`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetShopIdCoupon (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_shop_id_coupon`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetShopLiveDetail (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_shop_live_detail`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetDataEndLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_live_summary`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async IncrementLiveShareCount (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}increment_live_share_count`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async PinComment (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}pin_comment`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetPinnedComment (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_pinned_comment`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async CreateDealLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}create_deal_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ListDealLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}list_deal_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ExpireDealLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}expire_deal_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ListMissionCoupon (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_list_mission`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async RefreshToken () {
    const auth = await GetToken()
    if (localStorage.getItem('oneData') !== null) {
      var oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
      // console.log(oneData.user.user_id)
    }
    var data = {
      user_id: oneData.user.user_id
    }
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END}api/refresh_token_v2`, data, auth)
      if (response.data.message === 'Get Token Success') {
        oneData.user.access_token = response.data.data.access_token
        localStorage.setItem('oneData', Encode.encode(oneData))
      } else if (response.data.message === 'Refresh Token Success') {
        oneData.user.access_token = response.data.data.access_token
        localStorage.setItem('oneData', Encode.encode(oneData))
      }
      // return response.data
    } catch (error) {
      // return error.response.data
    }
  },
  async CheckMissionCoupon (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}check_in_mission`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async CheckCoupon (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END2}coupon/collect`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async StartLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}start_live`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ExportLiveHistoryExcel (val) {
    const auth = await GetToken()
    // console.log('ไหม')
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_LIVE_STREAM_API}export_live_history_excel`,
        val,
        {
          ...auth,
          responseType: 'blob'
        }
      )
      const blob = new Blob(
        [response.data],
        {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      )

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.download = 'LiveStreamReport.xlsx'
      link.click()

      window.URL.revokeObjectURL(url)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async checkQuestion (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}insert_demographic`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetShopLiveKit (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}api/stores`, val, auth)
      // var response = await axios.post('https://cannabis-debtor-reprocess.ngrok-free.dev/api/stores', val, auth)

      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetDataLiveStatus (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}api/dashboard-summary`, val, auth)
      // var response = await axios.post('https://cannabis-debtor-reprocess.ngrok-free.dev/api/dashboard-summary', val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetDataLiveDailySummary (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}api/stores/daily-summary`, val, auth)
      // var response = await axios.post('https://cannabis-debtor-reprocess.ngrok-free.dev/api/stores/daily-summary', val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetDataLiveTrend (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}api/camera-score/trend`, val, auth)
      // var response = await axios.post('https://cannabis-debtor-reprocess.ngrok-free.dev/api/camera-score/trend', val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async ViewSessionExportPDF (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}view_session/export_pdf`, val,
        {
          ...auth,
          responseType: 'blob'
        }
      )
      const blob = new Blob(
        [response.data],
        {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      )

      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.download = 'LiveStreamReport.pdf'
      link.click()

      window.URL.revokeObjectURL(url)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetMissionList (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}mission/admin/list`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async InsertMissionLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}mission/admin/insert`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async EditMissionLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}mission/admin/edit`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async GetListCouponOptionstMissionLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}mission/admin/list_coupon_options`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async InsertCouponCouponOptionstMissionLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}mission/admin/insertCoupon`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async UpdateCouponInMissionLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}mission/admin/updateCouponInMission`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  },
  async NotificationPushLive (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_BACK_END5}v1/notification-push/live`, val, auth)
      if (response) {
        return response.data
      }
    } catch (error) {
      return error
    }
  },
  async GetMissionTimer (val) {
    const auth = await GetToken()
    try {
      var response = await axios.post(`${process.env.VUE_APP_LIVE_STREAM_API}get_auto_live_mission`, val, auth)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }
}
